export const publisherStates = {
    LOADING: 'Loading',
    LOADED: 'Loaded',
    ERROR: 'Error',
    DEFAULT: 'Default'
}